module.exports = __webpack_public_path__ + "static/media/meal.6360d2fc.svg";